module.exports = __webpack_public_path__ + "img/leave-closure-warning.14dc1c82.png";